<template lang="pug">
section
  div
    | The Level 1 user is responsible
    | for all day-to-day management of the licence
    | via the Sponsorship Management System (SMS).

  div
    | At the application stage
    | the first appointed Level 1 user
    | has to be an employee
    | or an ‘office holder’ of the organisation.
    | However, once the licence is granted,
    | others, including legal representatives,
    | can be set up as Level 1 users.

  div
    | ✅
    |
    | Level 1 user must be one of the following:

  div
    b Application phase

  ul
    li
      | an employee, director or partner in your company;

  div
    b After licence is granted

  ul
    li
      | a paid staff member or office holder
      | within your organisation;
    li
      | an employee of a 3rd party organisation
      | engaged by you to deliver
      | all or part of your HR function;
    li
      | a UK-based representative.

  br

  div
    | ⛔
    |
    | Level 1 user must not be any of the following:

  ul
    li
      | a contractor;
    li
      | a consultant who is contracted
      | for a specific project;
    li
      | a temporary staff member
      | supplied by an employment agency;
    li
      | an undischarged bankrupt.

  br

  div
    | ❗
    |
    | You must always have a minimum of
    |
    u
      b ONE
    |
    | Level 1 user who is a
    |
    u settled person
    | ,
    | e.g. someone who is a British national
    | or has a settled status
    | -
    | Indefinite Leave to remain,
    | Permanent residency, Settled status
    | under EU Settlement Scheme, etc.

  div
    | The only exceptions to this are:

  ul
    li
      | when the sponsoring organisation is licensed
      | under the International Agreement Worker route;
    li
      | when the Authorising Officer is a person
      | with valid leave to remain in the UK
      | under the following visa categories:

    ul
      li
        | Representative of an Overseas Business
      li
        | Tier 1 (Graduate Entrepreneur)
      li
        | Tier 1 (Entrepreneur)
      li
        | Tier 1 (Exceptional Talent)
      li
        | Innovator
      li
        | Start Up
      li
        | Global Talent Migrant
</template>

<script>
export default {
  name: "key_personnel_level_1",
};
</script>